import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Breadcrumb, Button } from '@themesberg/react-bootstrap';
import { UserlistTable } from "../components/Userlist";
import { Link } from 'react-router-dom';
import { Routes } from "../routes";

export default () => {
  // Get the logged-in user from localStorage (assuming it's saved as 'authToken')
  const loggedInUser = JSON.parse(localStorage.getItem("authToken"));
  const isManagement = loggedInUser && loggedInUser.user_type === "0" || loggedInUser && loggedInUser.user_type === "1" ; // Check if user_type is '0' for Management

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mt-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item> <Link to={"/dashboard/overview"}><FontAwesomeIcon icon={faHome} /></Link>  </Breadcrumb.Item>
            <Breadcrumb.Item active>User Details</Breadcrumb.Item>
          </Breadcrumb>
          <h4>User Details</h4>
        </div>

        {/* Render Add New button only if the user is Management */}
        {isManagement && (
          <div className="btn-toolbar mb-2 mb-md-0">
            <Button as={Link} to={Routes.Forms.path} variant="primary" size="sm" className="me-2">
              <FontAwesomeIcon icon={faPlus} className="me-1" /> Add New
            </Button>
          </div>
        )}
      </div>

      <UserlistTable />
    </>
  );
};
